;(function (n, t, i, r) {
  var u, f
  ;(n[i] = n[i] || {}),
    (n[i].initial = { accountCode: 'METRI11117', host: 'METRI11117.pcapredict.com' }),
    (n[i].on =
      n[i].on ||
      function () {
        ;(n[i].onq = n[i].onq || []).push(arguments)
      }),
    (u = t.createElement('script')),
    (u.async = !0),
    (u.src = r),
    (f = t.getElementsByTagName('script')[0]),
    f.parentNode.insertBefore(u, f)
})(window, document, 'pca', '//METRI11117.pcapredict.com/js/sensor.js')

/**
 * Manually dispatch the event to React - https://github.com/facebook/react/issues/11488#issuecomment-347775628
 * required addition of https://github.com/facebook/react/issues/11488#issuecomment-636380481
 * as https://github.com/facebook/react/issues/10135#issuecomment-314441175 no longer works
 */
var setValue = function (element, value) {
  element.value = value
  let event = new Event('change', { bubbles: true })
  event.simulated = true
  let tracker = element._valueTracker
  if (tracker) {
    tracker.setValue('')
  }
  element.dispatchEvent(event)
}

pca &&
  pca.on('load', function (type, id, control) {
    control.listen('populate', function (address) {
      control.fields.forEach(function (x) {
        var input = document.querySelector(`[name="${x.element}"]`)
        setValue(input, address[x.field.replace(/({|})/g, '')])
      })
    })
  })
